import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import PageLoader from './ui/PageLoader';
import PublicHomePage from './home/PublicHomePage';
import AuthenticatedHomePage from './home/AuthenticatedHomePage';

/**
 * Thin auth gate for `/`.
 * Waits for AuthContext.isLoading so signed-in users never flash the marketing homepage.
 */
export default function Home() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <PageLoader message="Loading…" />;
  }

  return isAuthenticated ? <AuthenticatedHomePage /> : <PublicHomePage />;
}
